jQuery(function () {
  const selector = '[data-behaviour~="assign-specialties"]';

  // BEHAVIOUR

  jQuery(document).on("click", selector, handleClick);

  // HELPER FUNCTIONS

  async function handleClick(event) {
    event.preventDefault();

    const modal = document.querySelector("sp-assign-specialties-app");
    const whenMountReady = window.Sparkle?.CustomElements?.whenMountReady;
    if (!modal || !whenMountReady) {
      return;
    }

    // `open()` exists only post-mount — await the mount-ready contract.
    try {
      await whenMountReady(modal);
    } catch (error) {
      console.error("sp-assign-specialties-app failed to load; the Assign Specialties modal is unavailable", error);
      return;
    }

    modal.open();
  }
});
